import { utils, writeFileXLSX } from "xlsx";

class CommonUtils {
  tableDateFormatter(date) {
    if (date === "" || date === "01/01/0001" || date === "NaN/NaN/NaN") {
      return "";
    } else if (sessionStorage.userLanguage === "en-uk") {
      const dateArray = date.split("/");
      return `${dateArray[1]}/${dateArray[0]}/${dateArray[2]}`;
    } else {
      return date;
    }
  }

  //* Sort use for Print, Export pdf, csv, xls
  exportTableSort(data, sortColumnText, sortType) {
    const index = data.headCells.findIndex((x) => x.label === sortColumnText);
    const key = data.headCells[index].key;

    function getCurrentUrl(thePath) {
      return thePath.substring(thePath.lastIndexOf("/") + 1);
    }
    const getCurrentScreen = getCurrentUrl(window.location.href);

    function formatDate(date) {
      // convert the date from mm/dd/yyyy -> dd/mm/yyyy
      if (sessionStorage.userLanguage === "en-uk") {
        const dateArray = date.toString().split("/");
        return `${dateArray[1]}/${dateArray[0]}/${dateArray[2]}`;
      } else {
        return date;
      }
    }

    if (
      getCurrentScreen === "fleetSurvey" ||
      getCurrentScreen === "fleetData" ||
      getCurrentScreen === "tireForecast" ||
      getCurrentScreen === "tireInflationReport" ||
      getCurrentScreen === "tireRotation" ||
      getCurrentScreen === "tireFlipping"
    ) {
      /* this sort function is under Vehicle report */

      if (sortType === "ascending") {
        data.rowsData.map((vehicle) => {
          vehicle.sort((a, b) => {
            if (sortColumnText.includes("Date") || sortColumnText.includes("Last Read") || sortColumnText.includes("Last Account Edit")) {
              return new Date(formatDate(a[key])) - new Date(formatDate(b[key]));
            } else {
              return a[key] > b[key] ? 1 : -1;
            }
          });
          return vehicle;
        });
      } else {
        data.rowsData = data.rowsData.map((vehicle) => {
          vehicle.sort((a, b) => {
            if (sortColumnText.includes("Date") || sortColumnText.includes("Last Read") || sortColumnText.includes("Last Account Edit")) {
              return new Date(formatDate(b[key])) - new Date(formatDate(a[key]));
            } else {
              return b[key] > a[key] ? 1 : -1;
            }
          });
          return vehicle;
        });
      }
      return data;
      /* end of function under Vehicle report */
    } else {
      if (sortType === "ascending") {
        data.rowsData = data.rowsData.sort((a, b) => {
          if (sortColumnText.includes("Date") || sortColumnText.includes("Last Read") || sortColumnText.includes("Last Account Edit")) {
            return new Date(formatDate(a[key])) - new Date(formatDate(b[key]));
          } else {
            return a[key] > b[key] ? 1 : -1;
          }
        });
      } else {
        data.rowsData = data.rowsData.sort((a, b) => {
          if (sortColumnText.includes("Date") || sortColumnText.includes("Last Read") || sortColumnText.includes("Last Account Edit")) {
            return new Date(formatDate(b[key])) - new Date(formatDate(a[key]));
          } else {
            return b[key] > a[key] ? 1 : -1;
          }
        });
      }
      return data;
    }
  }

  //  (Date format ISO 8601) sample date: 2022-04-01T07:32:38.027
  formatISODate(date) {
    if (sessionStorage.userLanguage === "en-uk") { // convert the date from mm/dd/yyyy -> dd/mm/yyyy
      const dateTimeString = date.split("T");
      const dateString = dateTimeString[0].split("-");
      return `${dateString[2]}/${dateString[1]}/${dateString[0]}`;
    } else {
      const dateTimeString = date.split("T");
      const dateString = dateTimeString[0].split("-");
      return `${dateString[1]}/${dateString[2]}/${dateString[0]}`;
    }
  }

  getDateFormat() {
    if (sessionStorage.userLanguage === "en-uk") {
      return "dd/MM/yyyy";
    } else {
      return "MM/dd/yyyy";
    }
  }

  getCurrentUrl(thePath) {
    return thePath.substring(thePath.lastIndexOf("/") + 1);
  }

  removeLeadingSpaces(str) {
    return str.trimStart();
  }

  minmaxFloat(value, min, max) {
      if(parseFloat(value) < min || isNaN(parseFloat(value))) 
          return min; 
      else if(parseFloat(value) > max) 
          return max; 
      else return parseFloat(value);
  }

  minmaxInt(value, min, max) {
    if(parseInt(value, 10) < min || isNaN(parseInt(value, 10))) {
      return min; 
    }
    else if(parseInt(value, 10) > max) {
      return max; 
    }
    else return parseInt(value, 10);
     
}
  // use for PDF
  calculateAspectRatioFit = (srcWidth, srcHeight, maxWidth, maxHeight) => {
    let ratio = srcWidth / srcHeight;
    let width = maxWidth;
    let height = maxHeight;
    if (srcWidth <= maxWidth && srcHeight <= maxHeight) {
      // source less that maximum size print as it is
      width = srcWidth;
      height = srcHeight;
    } else if (srcWidth >= srcHeight) {
      //width is larger
      height = maxWidth / ratio;
      if (height > maxHeight) {
        //calculated height greater than maxheight reallocate by adjusting height
        height = maxHeight;
        width = maxWidth * ratio;
        if (width > maxWidth) {
          width = maxWidth;
        }
      }
    } else {
      width = maxHeight * ratio;
      if (width > maxWidth) {
        //calculated width greater than maxWidth reallocate by adjusting width
        height = maxWidth / ratio;
        width = maxWidth;
      }
    }
    return { width: width, height: height };
  };

  //* Simple Level1 array sort
  singleArraySort(arrayData,sortingItem) {
    let sortedArray = arrayData.sort((a, b) => {
      if (a[sortingItem] > b[sortingItem]) {
        return 1;
      } else if (a[sortingItem] < b[sortingItem]) {
         return -1;
      } else {
       return 0;
      } 
    })
    return sortedArray;
  }

  //* fOR PDF WHEN USING IMAGE RELATED
  getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
      let img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        let canvas = document.createElement("canvas");
        canvas.width = 90;
        canvas.height = 25;

        let ctx = canvas.getContext("2d");
        let wrh = img.width / img.height;
        let newWidth = canvas.width;
        let newHeight = newWidth / wrh;
        if (newHeight > canvas.height) {
          newHeight = canvas.height;
          newWidth = newHeight * wrh;
        }
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        img.src = canvas.toDataURL("image/png");
        let dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      img.onerror = (error) => {
        reject(error);
      };

      img.src = url;
    });
  }


  //* GENERATE RANDOM HEX VALUE FOR COLOR
  // this function replaces Math/random due to security purposes
  generateRandomNumber() {
    const cryp = window.crypto || window.msCrypto;
    let tab = new Uint32Array(1); //whole number
    return cryp.getRandomValues(tab)[0];
  }

  generateRandomHexColorString() {
    let hexCode = Math.floor(Math.abs(Math.sin(this.generateRandomNumber()) * 16777215)).toString(16);
    let hexSign = "#";
    return hexSign.concat(hexCode).toUpperCase();
  }

  //this function replace the frontend functions generating color hex
  getRandomColorHex = () => {
    let colorArr = this.colorArr; //dependent to available color array below
    let colorArrLen = colorArr.length;
    for (let index = 0; index < colorArrLen; index++) {
      let color = this.generateRandomHexColorString();
      colorArr.push(color);
    }
    return colorArr;
  };

  wornPercentageClass = (wornPercentage) => {
    
    if (wornPercentage < 25) {
      return 'table-content-text percent-worn-low';
    } else if (wornPercentage < 50) {
      return 'table-content-text percent-worn-mid';
    } else if (wornPercentage < 75) {
      return 'table-content-text percent-worn-high';
    } else {
      return 'table-content-text percent-worn-highest';
    }
  };

  wornPercentageInfo = (wornPercentage) => {
    
    if (wornPercentage < 25) {
      return 'Percentage worn less 25%: Safe';
    } else if (wornPercentage < 50) {
      return 'Percentage worn less 50%: warning';
    } else if (wornPercentage < 75) {
      return 'Percentage worn less 75%: warning';
    } else {
      return 'Percentage worn higher than 75%: Danger';
    }
  };


  pdfHeaderNameShorter = (headCell) => {

    let userPref = JSON.parse(localStorage.getItem("accountInfo"));
    let noOfTreadDepthReadings = parseInt(localStorage.getItem("noOfTreadDepthReadings"),10);

    const checkThreadDepthReading = (treadDepthReading) => {
      if (treadDepthReading === 1) {
        return 'O'
        } else if (treadDepthReading === 2) {
          return 'O, I'
        } else {
          return 'O, C, I'
        }
    }


    let headerText = ""; 
    switch (headCell) {
      case "WheelPosition":
        headerText = "Wheel POS";
        break;

      case "Position":
        headerText = "POS";
        break;
      
      case "SerialNo":
      case "Serial":
      case "SerialNumber":
        headerText = "Serial #";
        break;
      
      case "RimSerialNumber":
        headerText = "Rim Serial #";
        break;
      
      case "BrandNo":
      case "Brand":
      case "BrandNumber":
        headerText = "Brand #";
        break;

      case "EvaluationNo":
      case "Eval":
        headerText = "Eval #";
        break;

      case "TypeName":
        headerText = "Type";
        break;

      case "SizeName":
        headerText = "Size";
        break;

      case "VehicleType":
      case "VehicleTypeName":
        headerText = "VEH Type";
        break;

      case "NumberOfTires":
        headerText = "No. of Tires";
        break;

      case "AverageHours":
        headerText = "AVG Hrs";
        break;

      case "AverageWorn":
        headerText = "AVG Worn (%)";
        break;

      case "AverageWearRate":
        headerText = "AVG Wear Rt";
        break;

      case "ManufacturerName":
      case "Manufacturer":
      case "MakeName":
        headerText = "Manf.";
        break;

      case "ModelName":
        headerText = "Model";
        break;
      
      case "AxleConfg":
        headerText = "Axle Confg";
        break;

      case "LastRead":
        headerText = "Last Read";
        break;  
      
      case "VehicleManufacturerName":
        headerText = "VEH Manf.";
        break;

      case "Compound":
      case "CompoundName":
        headerText = "COMP";
        break;

      case "RatingName":
        headerText = "Rate";
        break;

      case "TreadDepth":
        headerText = `RTD/OTD ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? '(32")' : '(mm)'}
        ${checkThreadDepthReading(noOfTreadDepthReadings)} /ORG`;
        break;

      case "PercentageWorn":
        headerText = "% Worn";
        break;

      case "InspectDate":
        headerText = "Insp Date";
        break;

      case "TotalHours":
        headerText = "Total Hrs";
        break;

      case "TotalCost":
        headerText = "Total Cost";
        break;

      case "TotalMiles":
        headerText = `Total ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'}`;
        break;

      case "TotalKm":
      headerText = "Total Km";
      break;

      case "RecomPressure":
        headerText = "RCMDD PRS (H/C) " + userPref.userSetting.userPressureUnit;
        break;

      case "Pressure":
        headerText = "PRS (H/C) " + userPref.userSetting.userPressureUnit;
        break;

      case "PercentRecomPressure":
        headerText = "% RCMDD PRS";
        break;

      case "HoursPerTreadDepth":
        headerText = `Hrs/ ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? '32"' : 'mm'}`;
        break;

      case "ProjectedHours":
        headerText = "PROJ Hrs";
        break;

      case "ProjectedCost":
        headerText = "PROJ Cost";
        break;

      case "HoursLeft":
        headerText = "Hrs Left";
        break;

      case "ProjectedRemovalDate":
        headerText = "PrjRMVL Date";
        break;

      case "Total Cost Before Adjustment":
        headerText = "Total Cost Before Adjust.";
        break;

      case "Adjustment Cost/Hour":
        headerText = "Adjust. Cost/Hr";
        break;

      case "Org Vehicle #":
      case "OriginalVehicleNumber":
        headerText = "Org VEH #";
        break;

      case "OutsideTread":
        headerText = "Outs. Tread";
        break;

      case "InsideTread":
        headerText = "Ins. Tread";
        break;

      case "OriginalTread":
        headerText = "ORIG Tread";
        break; 

      case "TireSerialNo":
        headerText = "Tire Serial #";
        break;        

      case "TireCount":
        headerText = "Tire Cnt";
        break; 

      case "NewCost":
        headerText = "New Cost";
        break; 

      case "CostPerHour":
        headerText = "Cost/Hr";
        break; 
      
      case "CostPerMile":
        headerText = `Cost/${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'}`;
        break; 

      case "Disposition":
      case "DispositionName":
        headerText = "DISP";
        break; 

      case "RegisteredDate":
        headerText = "Reg. Date";
        break; 

      case "FirstInstallationDate":
        headerText = "1st INSTD Date";
        break;

      case "PoNumber":
        headerText = "Po #";
        break;        

      case "ReasonName":
        headerText = "Reason";
        break; 

      case "AverageCostPerHour":
        headerText = "AVG Cost/Hr";
        break; 

      case "MoneyLost":
        headerText = "Money Lost";
        break; 

      case "PercentageTotal":
        headerText = "% Total";
        break; 

      case "RemovalReason":
        headerText = "RMVL RSN";
        break; 

      case "NoOfRetread":
        headerText = "# of Retread";
        break;

      case "RetreadCost":
        headerText = "Retread Cost";
        break;

      case "NoOfRepair":
        headerText = "# of Repair";
        break;

      case "AverageCost":
        headerText = "AVG Cost";
        break;

      case "AverageProjHours":
        headerText = "AVG PROJ Hrs";
        break; 

      case "CostPerHourProj":
        headerText = "Cost/Hr PROJ";
        break;

      case "CasingValue":
        headerText = "Casing Val";
        break; 

      case "CostAdjustment":
        headerText = "Cost ADJ";
        break;

      case "WarrantyAdjustment":
        headerText = "WNTY ADJ";
        break;

      case "TireSerialNumber":
        headerText = "Tire Serial #";
        break;

      case "DateOfFirstFitment":
        headerText = "1st Fitment Date";
        break;
    
      case "EquipNo":
        headerText = "Equip #";
        break;

      case "AssetNumber":
        headerText = "Asset #";
        break;

      case "InspDate":
        headerText = "Insp Date";
        break;

      case "CurrentEquipHours":
        headerText = "Curr Equip Hrs";
        break;

      case "AchievedlHrsFront":
        headerText = "Ach Hrs Frt";
        break;

      case "AchievedHrsRear":
        headerText = "Ach Hrs Rr";
        break;

      case "RepairLife":
        headerText = "Repair Life";
        break;

      case "Otd":
        headerText = "Otd";
        break;

      case "Otd_A":
        headerText = "Otd A";
        break;

      case "Otd_B":
        headerText = "Otd B";
        break;

      case "AvgOtd":
        headerText = "AVG Otd";
        break;

      case "HrPerMm":
        headerText = "Hr/Mm";
        break;
      
      case "PressureType":
        headerText = "PRS Type";
        break;
      
      case "CurrentPressure":
        headerText = "Curr PRS";
        break;

      case "CurrentHours":
        headerText = "Curr Hrs";
        break;
      
      case "InstallationDate":
      case "InstalledDate":
        headerText = "INSTD Date";
        break;

      case "VehicleId":
        headerText = "VEH ID";
        break;

      case "CostHourProj":
        headerText = "Cost/Hr PROJ";
        break;

      case "RepairRetreadCount":
        headerText = "Repair Retread Count";
        break;

      case "TotalCostBeforeAdjustment":
        headerText = "Total Cost Bef Adjust.";
        break;

      case "AdjustmentCost":
        headerText = "Adjust. Cost";
        break;

      case "MilesPerTreadDepth":
        headerText = "Miles/TrdDpt";
        break;        

      case "AdjustmentCostPerHour":
        headerText = "Adjust. Cost/Hr";
        break;

      case "AdjustmentCostPerMile":
        headerText = `Adjust. Cost/${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Mile' : 'KM'}`;
        break;

      case "RemovedDate":
        headerText = "RMVD Date";
        break;

      case "RepairCost":
        headerText = "Repair Cost";
        break;

      case "AverageHoursPerMM":
        headerText = "AVG Hrs/Mm";
        break;    

      case "VehicleModel":
        headerText = "VEH Model";
        break;

      case "HoursAtRemoval":
        headerText = "Hrs at RMVL";
        break; 

      case "MilesAtRemoval":
        headerText = `${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'} At RMVL`;
        break; 

      case "AverageWearRateByMiles":
      case "AverageWearRatePerMile":
        headerText = `AVG Wear Rt (${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'})`;    
        break;

      case "AverageCostPerMile":
        headerText = `AVG Cost/${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Mile' : 'KM'}`;    
        break;

      case "AverageMiles":
        headerText = `AVG ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'}`;    
        break;

      case "ProjectedMiles":
        headerText = `Proj ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'}`;    
        break;

      case "ProjectedCostByMiles":
        headerText = `Proj Cost (${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'})`;    
        break;
  
      case "MilesLeft":
        headerText = `${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'} Left`;    
        break;
    
      case "ProjectedRemovalDateByMiles":
      headerText = `PrjRMVL Date (${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'})`;    
      break;
    
      case "WearRatePerMile":
        headerText = `Wear Rt (${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'})`;
        break;

      case "WearCondition":
        headerText = "Wear Condition";
        break;

      case "AverageMilesPerMM":
        headerText = `AVG ${userPref.userSetting.userMeasurementSystemValue === 'imperial' ? 'Miles' : 'KM'}/MM`;
        break;
      
      case "VehicleStatus":
        headerText = "Veh Stat";
        break; 

      case "VehPos":
        headerText = "Veh Pos";
        break; 

      case "VehicleNumber":
        headerText = "Vehicle #";
        break;

      case "RimSerialNo":
        headerText = "Rim Serial #";
        break; 

      case "TorqueValue":
        headerText = "Torque Value";
        break; 
          
      case "CheckInterval":
        headerText = "Check Interval";
        break; 
      
      case "NextCheck":
        headerText = "Next Check";
        break; 
      
      case "EntryDate":
        headerText = "Entry Date";
        break; 
             
      case "ProjectedRotationDate":
        headerText = "PrjRotation Date";
        break;
        
      default:
        headerText = headCell;
        break;
    }

    return headerText;
  }

  pdfReportName = (reportName) => {
    if (reportName.includes("_")) {
      let result = reportName.split('_').join(' ');
      return result
    } else {
      return reportName;
    }
  };

  rowPerPageSelector = (rowDataLength) => {
    let arr = [];
    if (rowDataLength > 15) {
      arr.push(15);
    }
    if (rowDataLength > 30) {
      arr.push(30);
    }
    if (rowDataLength > 50) {
      arr.push(50);
    }
    arr.push(rowDataLength);
    return arr;
  };

  generateXls = async (xlsData) => {
    const raw_data = xlsData.rowsData;

    /* flatten objects */
    const rows = raw_data.map((row) => {
      let obj = {};
      xlsData.headCells.forEach((h) => {
        let key = h.value;
        if (key !== "Key" && xlsData.selectedColShow[key] === true && key !== "Action" && key !== "Actions") {
          obj[h.value] = row[h.value];
        }
      });
      return obj;
    });
    /* generate worksheet and workbook */
    const worksheet = utils.json_to_sheet(rows);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Dates");

    /* fix headers */
    let headers = xlsData.headCells.map((h) => h.label);
    utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

    /* create an XLSX file and try to save to Presidents.xlsx */
    writeFileXLSX(workbook, xlsData.reportName + ".xlsx");
  };


  GoodyearSVGLogo =
      '<svg xmlns="http://www.w3.org/2000/svg" width="98" height="38" viewBox="0 0 98 38"> <g id="Goodyear_Logo_38px" transform="translate(15433 3244)"> <rect id="Rectangle_1295" data-name="Rectangle 1295" width="98" height="38" transform="translate(-15433 -3244)" fill="#fff" opacity="0"/> <g id="Group_3470" data-name="Group 3470" transform="translate(-15431.754 -3234.719)"> <path id="Path_169" data-name="Path 169" d="M437.23,745.447a.246.246,0,0,1,.1.367l-.576.87c-.074.11-.16.159-.353.036a2.977,2.977,0,0,0-1.511-.432c-.685,0-1.325.2-1.457.686l-1.091,4.632c-.11.454.233.674.711.674h.294a.206.206,0,0,0,.221-.184l.625-2.659a.328.328,0,0,1,.306-.245h3.37a.2.2,0,0,1,.184.245l-.931,3.945a.353.353,0,0,1-.306.246h-4.791a3.217,3.217,0,0,1-3.284-3.5c0-3.578,2.745-5.306,5.992-5.306a4.916,4.916,0,0,1,2.5.624m11.335,3.149a5.043,5.043,0,0,1-5.293,5.22c-2.4,0-4.3-1.2-4.3-3.738a5.133,5.133,0,0,1,5.465-5.256c2.415,0,4.13,1.225,4.13,3.773m-3.554-1.569c.148-.6-.036-.883-.5-.883-.551,0-.7.245-.87.98l-1.066,4.473c-.134.576-.036.895.49.895s.7-.245.846-.846Zm14.018,1.569a5.043,5.043,0,0,1-5.293,5.22c-2.4,0-4.3-1.2-4.3-3.738a5.133,5.133,0,0,1,5.465-5.256c2.414,0,4.13,1.225,4.13,3.773m-3.554-1.569c.148-.6-.036-.883-.5-.883-.552,0-.7.246-.87.98l-1.066,4.473c-.135.576-.036.895.49.895s.7-.245.846-.846ZM466.134,745a3.052,3.052,0,0,1,3.356,3.248c0,2.683-1.789,5.378-4.89,5.378h-5.28a.2.2,0,0,1-.184-.245l1.924-8.136c.049-.184.122-.245.307-.245Zm-.269,2.022c.135-.576-.037-.673-.907-.673a.229.229,0,0,0-.245.184l-1.312,5.526c-.036.159.013.22.135.22.795,0,1.091,0,1.225-.551Zm5.123,7.524a6.032,6.032,0,0,1-2.7,1.6.24.24,0,0,1-.246-.258c0-1,1.1-1.519,1.532-2.341a20.488,20.488,0,0,0,.845-2.34,8.92,8.92,0,0,1,1.164-2.438c.539,1.054,1.225,2.327,1.728,3.393-.686.7-1.494,1.581-2.328,2.377m6.568-4.987a.644.644,0,0,1,.233.442c-3.566,1.752-5.452,5.759-9.128,7.066a1.333,1.333,0,0,1-.233-.478c3.553-1.262,5.367-5.318,9.128-7.033m-6.96-4.816a38.927,38.927,0,0,1,3.541-2.009A4.517,4.517,0,0,0,474,743.82a2.12,2.12,0,0,0,.135.833l-2.65,1.519a16.665,16.665,0,0,1-.9-1.433M471.754,748c.025-.319.062-.625.062-.943a2.045,2.045,0,0,0-.025-.38,18.46,18.46,0,0,1,2.1.171v.1A14.391,14.391,0,0,1,471.753,748m2.672-.736a4.4,4.4,0,0,0,1.054,1.606c.514-.16.6-.772,1.054-.993l.82,1.274a22.112,22.112,0,0,0-3.688,2.732c-.637-1.148-1.213-2.208-1.728-3.308a19.43,19.43,0,0,1,2.488-1.312m-.123-2.181h.148l-.1,1.237a4.189,4.189,0,0,1-.564.025c-.429,0-.87-.025-1.458-.073Zm12.216-4.092c0,1.544-2.132,1.985-3.639,1.985-.76,0-1.555-.074-2.291-.11v.1l.686.269c-.025.514-.845.442-1.287.624.088.11.283.037.283.172v.037a1.463,1.463,0,0,1-1.127.454,2.069,2.069,0,0,1-.809-.16l-.088.088v.294c0,.245-.062,1.25-.353,1.25-.172,0-.282-.148-.442-.233-.123.33-.073.795-.33,1.078-.22,0-.392-.294-.587-.367a6.715,6.715,0,0,1-.785,1.569c-.735-.123-.883-1.312-.883-2.031a4.212,4.212,0,0,1,.088-.87,2.769,2.769,0,0,1-.5-1.495c0-1.96,2.1-2.549,3.578-2.549s2.928.185,4.46.185a21.71,21.71,0,0,0,4.031-.367Zm-10.439,3.86-.147-.686-.539-.049.061.1c.38.036.306.539.625.637m2.61-2.781a.617.617,0,0,1-.2.037c-.184,0-.38-.11-.53-.11a.318.318,0,0,0-.269.2c-.208.2-.539.171-.795.208a.846.846,0,0,1-.7.53.983.983,0,0,0,.442.109.617.617,0,0,0,.246-.049.854.854,0,0,1,.747-.265c.393,0,.344-.442.613-.442a.618.618,0,0,1,.109.025c.123-.037.331-.123.331-.233m2.168,7.818-1.458-4.644c-.049-.159.012-.245.171-.245h3.59a.329.329,0,0,1,.319.245l.833,2.683,2.156-2.683a.572.572,0,0,1,.454-.245h1.714c.147,0,.172.088.037.245l-3.871,4.694-.821,3.445a.353.353,0,0,1-.306.245h-3.468a.2.2,0,0,1-.184-.245ZM496.271,745a.2.2,0,0,1,.184.245l-.24,1.041a.353.353,0,0,1-.306.246H493.3a.353.353,0,0,0-.294.245l-.353,1.495c-.012.1.036.147.147.147h1.6a.2.2,0,0,1,.184.246l-.232,1.041a.353.353,0,0,1-.306.245h-1.59a.209.209,0,0,0-.22.134l-.442,1.826c-.025.123.011.185.134.185h2.659a.2.2,0,0,1,.184.246l-.245,1.04a.353.353,0,0,1-.306.246h-6.555a.2.2,0,0,1-.185-.246l1.924-8.136c.049-.184.123-.245.306-.245Zm8.308,8.381a.233.233,0,0,1-.221.245h-3.37a.26.26,0,0,1-.269-.246l-.1-.919a.187.187,0,0,0-.208-.184H497.8a.334.334,0,0,0-.294.184l-.563.919a.467.467,0,0,1-.392.246H495.3c-.123,0-.171-.123-.1-.246l4.938-8.16a.436.436,0,0,1,.391-.246h2.915a.259.259,0,0,1,.269.246Zm-4.386-2.65c.123,0,.184-.061.171-.184l-.22-2.144c-.012-.11-.1-.123-.172,0l-1.262,2.144c-.073.123-.049.184.074.184ZM512.96,745c2.34,0,3.1,1.116,3.1,2.353a3.673,3.673,0,0,1-1.678,3.136.258.258,0,0,0-.135.319l.563,2.561c.025.135-.025.258-.184.258h-3.6a.3.3,0,0,1-.294-.246l-.453-2.1c-.025-.123-.05-.221-.171-.221h-.123c-.122,0-.208.061-.245.233l-.49,2.083a.353.353,0,0,1-.306.246h-3.467a.2.2,0,0,1-.185-.246l1.924-8.136c.049-.184.122-.245.306-.245Zm-.943,2.022c.134-.576-.036-.673-.907-.673a.229.229,0,0,0-.246.184l-.7,2.965c-.036.159.012.221.134.221.795,0,1.078,0,1.213-.551Zm4.395,5.078a.768.768,0,1,1-.547.225.772.772,0,0,1,.547-.225m0,1.372a.6.6,0,1,0-.6-.6.6.6,0,0,0,.6.6m.123-.539.232.38h-.184l-.208-.367h-.1v.367H516.1v-.859h.318c.159,0,.33.037.33.233a.24.24,0,0,1-.22.245m-.1-.123c.088,0,.147-.012.147-.123,0-.049-.012-.1-.147-.1h-.159v.22Z" transform="translate(-428.738 -740.914)" fill="#ffe600"/> <path id="Path_170" data-name="Path 170" d="M516.168,765.182a1.606,1.606,0,0,1,1.684-1.124c.948,0,1.254.5,1.087,1.124l-.6,2.261a1.6,1.6,0,0,1-1.684,1.124c-.948,0-1.254-.5-1.086-1.124Zm.306,2.242c-.088.329-.008.486.353.486a.548.548,0,0,0,.605-.486l.6-2.224c.088-.328.007-.487-.353-.487a.548.548,0,0,0-.605.487Z" transform="translate(-459.829 -749.205)" fill="#fff"/> <path id="Path_171" data-name="Path 171" d="M520.832,768.542,522,764.154h2.523l-.177.656h-1.619l-.3,1.131h1.21l-.177.655H522.25l-.518,1.943Z" transform="translate(-461.73 -749.24)" fill="#fff"/> <path id="Path_172" data-name="Path 172" d="M525.876,768.542l1.167-4.388h2.524l-.177.656h-1.619l-.3,1.131h1.21l-.177.655H527.3l-.518,1.943Z" transform="translate(-463.537 -749.24)" fill="#fff"/> <path id="Path_173" data-name="Path 173" d="M531.295,768.567l.153-.559h1.787l-.154.559Z" transform="translate(-465.478 -750.621)" fill="#fff"/> <path id="Path_174" data-name="Path 174" d="M536.512,764.813h-.874l.177-.656h2.655l-.177.656h-.874l-.992,3.732h-.9Z" transform="translate(-466.992 -749.24)" fill="#fff"/> <path id="Path_175" data-name="Path 175" d="M539.121,768.542l1.167-4.388h.9l-.474,1.787h.963l.474-1.787h.905l-1.167,4.388h-.9l.518-1.943h-.962l-.518,1.943Z" transform="translate(-468.282 -749.24)" fill="#fff"/> <path id="Path_176" data-name="Path 176" d="M544.8,768.542l1.167-4.388h2.422l-.177.656H546.7l-.3,1.131h1.167l-.177.655H546.22l-.344,1.289H547.5l-.177.656Z" transform="translate(-470.316 -749.24)" fill="#fff"/> <path id="Path_177" data-name="Path 177" d="M550.222,768.567l.153-.559h1.787l-.153.559Z" transform="translate(-472.258 -750.621)" fill="#fff"/> <path id="Path_178" data-name="Path 178" d="M554.533,768.542h-.905l1.167-4.388h1.268c1.014,0,1.438.359,1.189,1.294a1.456,1.456,0,0,1-.933,1.107l.24,1.987h-.919l-.161-1.818c-.117.012-.306.019-.467.019Zm.641-2.419h.321a.746.746,0,0,0,.853-.675c.139-.523-.007-.675-.5-.675h-.321Z" transform="translate(-473.478 -749.24)" fill="#fff"/> <path id="Path_179" data-name="Path 179" d="M560.325,765.182a1.6,1.6,0,0,1,1.684-1.125c.948,0,1.255.5,1.086,1.125l-.6,2.261a1.6,1.6,0,0,1-1.683,1.124c-.949,0-1.255-.5-1.088-1.124Zm.306,2.242c-.088.329-.007.486.353.486a.548.548,0,0,0,.605-.486l.6-2.224c.088-.328.008-.487-.353-.487a.549.549,0,0,0-.607.487Z" transform="translate(-475.648 -749.205)" fill="#fff"/> <path id="Path_180" data-name="Path 180" d="M565.318,768.542h-.874l2.137-4.388H567.7l-.2,4.388h-.876l.1-.972h-.992Zm.722-1.629h.729l.147-1.884H566.9Z" transform="translate(-477.353 -749.24)" fill="#fff"/> <path id="Path_181" data-name="Path 181" d="M571.2,764.154h1.343c.934,0,1.32.426,1.078,1.325l-.466,1.739a1.654,1.654,0,0,1-1.78,1.325h-1.342Zm-.1,3.768h.314a.7.7,0,0,0,.809-.614l.511-1.921c.124-.461-.008-.613-.489-.613h-.314Z" transform="translate(-479.356 -749.24)" fill="#fff"/> <rect id="Rectangle_516" data-name="Rectangle 516" width="94.507" height="19.364" transform="translate(0 -0.001)" fill="none"/> </g> </g> </svg>';
  EmTrackSVGLogo =
      '<svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24"> <g id="EMTrack_Logo_24px" transform="translate(-495 -176)"> <g id="Goodyear_Logo_38px" transform="translate(495 176)"> <rect id="Rectangle_1295" data-name="Rectangle 1295" width="36" height="24" fill="#fff" opacity="0"/> </g> <g id="Group_1542" transform="translate(496 179)"> <path id="Path_490" d="M179.7,280.836h2.737l2.531-4.235,3.822,6.559,4.751-8.16,3.357,5.836h3.77" transform="translate(-176.24 -275)" fill="none" stroke="#ffdd02" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/> <ellipse id="Ellipse_41" cx="0.826" cy="0.775" rx="0.826" ry="0.775" transform="translate(0 5.061)" fill="#ffdd02"/> <ellipse id="Ellipse_41_1_" cx="0.826" cy="0.775" rx="0.826" ry="0.775" transform="translate(26.082 5.061)" fill="#ffdd02"/> <g id="Group_3470" data-name="Group 3470" transform="translate(1.033 10.226)"> <path id="Path_4985" data-name="Path 4985" d="M179.338,299.965v1.085H175V294.8h4.235v1.085h-3.047v1.5h2.634v.981h-2.634v1.6Z" transform="translate(-175 -294.8)" fill="#fff"/> <path id="Path_4986" data-name="Path 4986" d="M190.361,301.049v-4.132l-1.6,3.047h-.671l-1.6-3.047v4.132H185.3V294.8h1.291l1.859,3.564,1.859-3.564H191.6v6.249Z" transform="translate(-179.98 -294.8)" fill="#fff"/> </g> <g id="Group_3471" data-name="Group 3471" transform="translate(13.428 10.071)"> <path id="Path_4987" data-name="Path 4987" d="M204.01,295.213h-2.272v5.836h-.465v-5.836H199V294.8h5.01Z" transform="translate(-199 -294.645)" fill="#fff" stroke="#fff" stroke-width="0.2"/> <path id="Path_4988" data-name="Path 4988" d="M210.618,298.413a1.948,1.948,0,0,0-1.085.362,1.662,1.662,0,0,0-.62.93v2.841H208.5V298h.413v1.136a2.286,2.286,0,0,1,.62-.775,1.7,1.7,0,0,1,.826-.362h.258Z" transform="translate(-203.594 -296.192)" fill="#fff" stroke="#fff" stroke-width="0.2"/> <path id="Path_4989" data-name="Path 4989" d="M214.946,302.6a1.86,1.86,0,0,1-.568-.1,1.425,1.425,0,0,1-.775-.775,2.2,2.2,0,0,1-.1-.568,1.177,1.177,0,0,1,.155-.568,1.057,1.057,0,0,1,.413-.413,2.235,2.235,0,0,1,.62-.258,3.984,3.984,0,0,1,.775-.1,3.173,3.173,0,0,1,.723.052c.258.052.465.1.671.155v-.465a1.407,1.407,0,0,0-.362-1.033,1.285,1.285,0,0,0-.981-.362,2.028,2.028,0,0,0-.723.155,2.832,2.832,0,0,0-.775.413l-.155-.31a2.867,2.867,0,0,1,1.653-.62,1.718,1.718,0,0,1,1.291.465,1.845,1.845,0,0,1,.465,1.343v2.221c0,.155.052.207.207.207v.413h-.207a.4.4,0,0,1-.258-.1.554.554,0,0,1-.1-.31v-.362a2.054,2.054,0,0,1-.826.62,3.118,3.118,0,0,1-1.136.31Zm.1-.362a1.769,1.769,0,0,0,.93-.207,1.678,1.678,0,0,0,.671-.516.558.558,0,0,0,.155-.362v-.826a2.556,2.556,0,0,0-.671-.207,3.175,3.175,0,0,0-.723-.052,2.514,2.514,0,0,0-.62.052.974.974,0,0,0-.465.207c-.1.1-.258.207-.31.31a.878.878,0,0,0,0,.826.927.927,0,0,0,.258.362.832.832,0,0,0,.362.207C214.688,302.186,214.843,302.238,215.049,302.238Z" transform="translate(-206.011 -296.092)" fill="#fff" stroke="#fff" stroke-width="0.2"/> <path id="Path_4990" data-name="Path 4990" d="M222.6,300.176a2.924,2.924,0,0,1,.155-.93,1.751,1.751,0,0,1,.465-.723,2.593,2.593,0,0,1,.723-.516,2.467,2.467,0,0,1,.93-.207,2.4,2.4,0,0,1,1.085.258,2.07,2.07,0,0,1,.723.775l-.413.155a1.211,1.211,0,0,0-.568-.568,1.515,1.515,0,0,0-.826-.207,1.823,1.823,0,0,0-.723.155,2.293,2.293,0,0,0-.568.413,1.24,1.24,0,0,0-.362.62,2.014,2.014,0,0,0,0,1.549,1.786,1.786,0,0,0,.362.62,2.293,2.293,0,0,0,.568.413,1.649,1.649,0,0,0,.723.155,1.43,1.43,0,0,0,.465-.052,1.038,1.038,0,0,0,.413-.207.927.927,0,0,0,.362-.258,1.081,1.081,0,0,0,.207-.31l.413.1a2.094,2.094,0,0,1-.258.465,1.4,1.4,0,0,1-.413.362,6.072,6.072,0,0,1-.568.258,2.592,2.592,0,0,1-.62.1,1.7,1.7,0,0,1-.878-.207,2.328,2.328,0,0,1-.723-.516,1.945,1.945,0,0,1-.465-.775,1.769,1.769,0,0,1-.207-.93Z" transform="translate(-210.409 -296.096)" fill="#fff" stroke="#fff" stroke-width="0.2"/> <path id="Path_4991" data-name="Path 4991" d="M235.805,300.9,234,298.477l-1.085.981V300.9H232.5v-6.4h.413v4.493l2.789-2.634h.516l-1.911,1.859,1.963,2.686Z" transform="translate(-215.198 -294.5)" fill="#fff" stroke="#fff" stroke-width="0.2"/> </g> </g> </g> </svg>';

  primaryYellow = "#ffdc00";
  primaryBlue = "#0055a4";
  disabledColor = "#d3d3d3"

  percentageWornColors = ["#00AF32", "#f0de00", "#EDBD00", "#ff0100"];
  percentageWornSecondaryColors = ["#16d513", "#f0de00", "#ffa502", "#ff0100"];

  borderColor = [
    "#009AC1",
    "#00409A",
    "#00671D",
    "#AF8B00",
    "#9B019B",
    "#910028",
    "#460096",
    "#A2B20F",
    "#AC4E00",
    "#FFC371",
    "#BFB01A",
    "#8D002F",
    "#5F9819",
    "#4EFF99",
    "#FFE512",
    "#6C6F16",
    "#5A5A5A",
    "#6D7B83",
    "#B0E0F4",
    "#558AB5",
    "#BC7057",
    "#9AE052",
    "#537430",
    "#206498",
    "#D38B92",
    "#EB9AC5",
    "#FFAAD5",
    "#5FBBFF",
    "#08655D",
    "#B9B9B9"
  ];
  colorArr = [
    "#00C7FA",
    "#3B79CF",
    "#00AF32",
    "#EDBD00",
    "#EA4EEA",
    "#EB4A75",
    "#9649EF",
    "#CDDD39",
    "#F57000",
    "#8E6E63",
    "#FFF276",
    "#F16292",
    "#F16292",
    "#004D41",
    "#837717",
    "#AFB42C",
    "#9E9E9E",
    "#91A4AE",
    "#546F7A",
    "#7BC1FA",
    "#FFAC91",
    "#2F7D33",
    "#7BB342",
    "#2197F3",
    "#FFCDD2",
    "#890D4F",
    "#9D27B0",
    "#3949AB",
    "#009688",
    "#E0E0E0"
  ];

  pieOptions = {
    responsive: true,
    maintainAspectRatio: true,
    title: {
      display: true,
      text: "",
      fontSize: 25,
      fontStyle: "normal"
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 20,
        bottom: 20
      }
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
        padding: {
          left: 0,
          right: 0,
          top: 0,
          bottom: -10
        },
        labels: {
          value: {
            color: "black",
            font: {
              weight: "bold",
              size: "10"
            }
          }
        },
        formatter: (value) => {
          return Math.round(value) + "%";
        }
      }
    },
    legend: {
      display: true,
      position: "right",
      labels: {
        fontColor: "#666666",
        fontSize: 12,
        padding: 19,
        usePointStyle: true,
        boxWidth: 15
      }
    }
  };

  barOptions = {
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
      yAlign: "top",
      xAlign: "center"
    },
    title: {
      display: true,
      text: "",
      fontSize: 25,
      fontStyle: "normal",
      padding: 20
    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 20,
        bottom: 20
      }
    },
    plugins: {
      datalabels: {
        anchor: "end",
        align: "end",
        labels: {
          value: {
            color: "black",
            font: {
              weight: "bold",
              size: "10"
            }
          }
        },
        formatter: (value) => {
          return Math.round(value);
        }
      }
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [
        {
          maxBarThickness: 80,
          align: "center",
          stacked: false,
          ticks: {
            display: true,
            fontSize: 16,
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: "",
            fontStyle: "bold",
            fontSize: 16,
            fontColor: "#333",
            align: "center"
          }
        }
      ],
      yAxes: [
        {
          display: true,
          scaleLabel: {
            display: true,
            labelString: "",
            fontStyle: "bold",
            fontSize: 16,
            fontColor: "#333"
          }
        }
      ]
    },
    cornerRadius: 10
  };

  viewTireLineOptions = {
    responsive: true,
    maintainAspectRatio: false,
    tooltips: {
      yAlign: "top",
      xAlign: "center"
    },
    title: {
      display: true,
      text: "",
      align: "center",
      fontSize: 10,
      fontStyle: "normalBarlow",
      padding: 15
    },
    layout: {
      margin: {
        top: 12
      },
      padding: {
        left: 0,
        right: 30,
        top: 5,
        bottom: 5
      }
    },
    plugins: {
      datalabels: {
        display: false
        // anchor: "end",
        // align: "end",
        // labels: {
        //   value: {
        //     color: "black",
        //     font: {
        //       weight: "bold",
        //       size: "10",
        //     },
        //   },
        // },
        // formatter: (value) => {
        //   return Math.round(value);
        // },
      }
    },
    legend: {
      display: false
    },
    scales: {
      xAxes: [
        {
          // maxBarThickness: 80,
          align: "center",
          gridLines: false,
          stacked: false,
          ticks: {
            display: true,
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: "",
            align: "center",
            fontColor: "#000000"
          }
        }
      ],
      yAxes: [
        {
          display: true,
          ticks: {
            display: true,
            beginAtZero: true
          },
          scaleLabel: {
            display: true,
            labelString: "",
            fontColor: "#505D6F"
          }
        }
      ]
    }
    // cornerRadius: 10,
  };
}
export default CommonUtils;
